import { EdeImportResultMsg } from 'src/constants/workTimeService';
import IsNil from 'ramda/es/isNil';
export const pluckDTOAnswerItem = (list, msg) => {
    const listCopy = [...list];
    const insertedResultIdx = listCopy.findIndex((row) => row.ResultMsg === msg);
    const [plucked] = insertedResultIdx >= 0 ? listCopy.splice(insertedResultIdx, 1) : [{}];
    return [listCopy, plucked];
};
export const parseDTOImportAnswer = (list) => {
    let inserted = 0;
    let ignored = 0;
    let updated = 0;
    const details = [];
    list.forEach((entry) => {
        const { ResultMsg } = entry;
        const ParameterValue = entry.ParameterValue ? +entry.ParameterValue : 0;
        if (ResultMsg === EdeImportResultMsg.Inserted)
            inserted = ParameterValue;
        else if (ResultMsg === EdeImportResultMsg.Ignored)
            ignored = ParameterValue;
        else if (ResultMsg === EdeImportResultMsg.Updated)
            updated = ParameterValue;
        else
            details.push(entry);
    });
    return ({
        inserted, ignored, updated, details
    });
};
export const parseDTOImportAnswerStats = (stats) => {
    const { Inserted, Ignored, Updated, Deleted } = stats;
    const parsed = {};
    if (!IsNil(Inserted))
        parsed.inserted = Inserted;
    if (!IsNil(Updated))
        parsed.updated = Updated;
    if (!IsNil(Ignored))
        parsed.ignored = Ignored;
    if (!IsNil(Deleted))
        parsed.deleted = Deleted;
    return parsed;
};
